import { AjaxLoader } from './ajax-load-promise';

class LoadComponents {
    constructor ($element) {
        this.$ajaxActions = $element;
        this.$components = this.$ajaxActions.querySelectorAll('[data-action-url]');
        this.loader = '<div class="loading is--small is--show"><b class="loading-dot"></b><b class="loading-dot"></b><b class="loading-dot"></b><b class="loading-dot"></b><b class="loading-dot"></b><b class="loading-dot"></b></div>';
    }

    initialize () {
        if (this.$components.length > 0) {
            this.loadComponents();
        }
    }

    loadComponents () {
        const load = (item) => {
            item.appendChild(this.createElementFromHTML(this.loader).firstChild);

            const url = item.getAttribute('data-action-url');

            if (url) {
                const result = AjaxLoader.getData(url);
                this.setResult(result, item, () => {
                    const $loader = item.querySelector('.loading');
                    const $firstContainer = item.querySelector('.is--loaded');

                    $loader.classList.add('is--hidden');

                    setTimeout(() => {
                        $firstContainer.classList.add('is--visible');
                    }, 400);

                    setTimeout(() => {
                        $loader.remove();
                    }, 800);
                });
            }
        };

        this.$components.forEach((item) => {
            const method = item.getAttribute('data-action-method');

            if (method === 'click') {
                const $trigger = item.querySelector(item.getAttribute('data-action-trigger'));

                if ($trigger) {
                    $trigger.addEventListener('click', () => {
                        if (!item.classList.contains('is--loaded')) {
                            load(item);
                            item.classList.add('is--loaded');
                        }
                    });
                }
            } else {
                load(item);
            }
        });
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.classList.add('is--loaded');
        div.innerHTML = htmlString;
        return div;
    }

    setResult (result, target, callback) {
        result.then((results) => {
            const $result = this.createElementFromHTML(results);
            target.appendChild($result);

            if (typeof callback === 'function') {
                callback();
            }
        });
    }
}

export { LoadComponents };
